exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-page .l-scroll .l-scroll-content{background:none}.review-page .detail-page{width:100%}.review-page .review-footer .l-button{padding:0 10px;min-width:85px}.review-page .review-footer .l-button+.l-button{margin-left:10px}", ""]);

// exports
